var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorizontalAlignLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15794_139176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.333 16V13H21.333V11L11.333 11V8L7.33301 12L11.333 16ZM3.33301 20H5.33301L5.33301 4H3.33301L3.33301 20Z",
    fill: "#303238"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15794_139176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0 -1 1 0 0.333008 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalAlignLeft);
export default __webpack_public_path__ + "static/media/horizontal_align_left.f222f9bcb718e2be672fa8d6d5c23f60.svg";
export { ForwardRef as ReactComponent };